export default __webpack_public_path__ + "components/bike-park-header/static/background--6-8d5486dcf856316153722687a1c43282.jpg";